import { AjaxObservable } from './AjaxObservable';
export var ajax = (function () { return AjaxObservable.create; })();
//# sourceMappingURL=ajax.js.map